export const USER_SHOW_RESET = 'USER_SHOW_RESET'
export const USER_SHOW_SET_ERROR = 'USER_SHOW_SET_ERROR'
export const USER_SHOW_SET_RETRIEVED = 'USER_SHOW_SET_RETRIEVED'
export const USER_SHOW_TOGGLE_LOADING = 'USER_SHOW_TOGGLE_LOADING'
